import { useMutation } from '@tanstack/react-query';
import { CALCULATIONS_MUTATION_KEY } from 'services/calculations/mutationKey';

import { SalesPlanApi } from '../salesPlan.api';

export const useGetAllProductsCalculations = () => {
  return useMutation({
    mutationKey: CALCULATIONS_MUTATION_KEY,
    mutationFn: SalesPlanApi.getAllProductsCalculations,
  });
};
